var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}],ref:_vm.chartRef,staticClass:"chart"})
}
var staticRenderFns = []

export { render, staticRenderFns }